import settings from './settings';

export default {
  namespaced: true,
  modules: {
    settings
  },
  state: {
    data: []
  },
  getters: {
    columns(state) {
      return state.settings.data.map(i => {
        return {
          value: i,
          text: i
        };
      });
    }
  },

  actions: {
    load({ commit }, params) {
      if (!params) {
        const list = [];
        list.length = 40;
        list.fill({
          id: 1,
          name: 'Name #',
          avatar: '',
          favorit: false,
          muted: false,
          status: 'Enabled',
          column1: 'Column1',
          column2: 'Column2',
          column3: 'Column3'
        });
        commit(
          'set',
          list.map((i, n) => {
            return {
              ...i,
              id: i.id + n,
              name: `${i.name}${n}`,
              avatar: 'mdi-image'
            };
          })
        );
        commit(
          'settings/set',
          Object.keys(list[0]).filter(i => i !== 'avatar')
        );
      }
    }
  }
};
